export default __webpack_public_path__ + "static/media/logo.3ab23b3b.jpg";